import { Box, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";
import { type ReactNode } from "react";

interface FieldShellProps {
  fieldKey: string;
  descriptionId?: string;
  isRequired: boolean;
  description?: string;
  children: ReactNode;
}

export function FieldShell({
  fieldKey,
  descriptionId,
  isRequired,
  description,
  children,
}: FieldShellProps) {
  return (
    <Stack spacing={0.75}>
      <Box sx={{ display: "block" }}>
        <Text semibold inline variant="body1">
          {fieldKey}
        </Text>
        {isRequired && (
          <Text
            inline
            variant="body1"
            sx={(theme) => ({ color: theme.palette.error.main, marginLeft: 0.5 })}
          >
            *
          </Text>
        )}
      </Box>
      {descriptionId && (
        <Text
          id={descriptionId}
          variant="body2"
          sx={(theme) => ({
            color: theme.palette.text.secondary,
            fontWeight: theme.typography.fontWeightRegular,
            fontSize: "0.875rem",
            lineHeight: 1.5,
          })}
        >
          {description}
        </Text>
      )}
      {children}
    </Stack>
  );
}
